module.exports = __webpack_public_path__ + "assets/media/s15.343484cd.mp3";